module.exports = __webpack_public_path__ + "img/title1.85fa2612.png";